
import backend from "@/utils/backend"
import * as types from "./mutation_types"
import { CHECK_AUTH } from "@/utils/apiUrl"
import router from "@/router"



export const getUserAuth = ({ commit }) => {
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_HIDE_MESSAGE)

    backend({ method: "GET", url: CHECK_AUTH }).then(({ data }) => {
        commit(types.SET_ITEMS, data?.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_IS_LOGIN, true)
        commit(types.SET_PERMISSIONS, data?.data?.permissions.map(({ name }) => (name)) ?? [])
    }).catch(() => {

        commit(types.RESET)
        localStorage.clear()
        router.push({ name: "AuthLogin" })


    }).finally(() => {

        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)

    })

}

export const logoutUser = ({commit})=>{
    localStorage.clear()
    commit(types.RESET)
    router.push({ name: "AuthLogin" })

}
export const checkToken = ({ commit }) => {
    return new Promise((res, rej) => {
        backend({ method: "GET", url: CHECK_AUTH }).then(({ data }) => {

            commit(types.SET_ITEMS, data?.data ?? data)

            commit(types.SET_IS_SUCCESS)
            commit(types.SET_IS_LOGIN, true)
            commit(types.SET_PERMISSIONS, data?.data?.permissions.map(({ name }) => (name)) ?? [])
            res("is Login")

        }).catch(() => {

            commit(types.RESET)

            localStorage.clear()
            rej("Not Login")


        })
    })



}


export const resetData = ({ commit }) => {
    commit(types.RESET)
}



